// src/components/Layout.js
import React, { useState, useEffect } from "react";
import { Outlet, NavLink, useNavigate, useLocation } from "react-router-dom";
import Notepad from "./Notepad";
import TopicSidebar from "./TopicSidebar";

const NAV = [
  { to: "/", icon: "⊞", label: "Dashboard" },
  { to: "/performance", icon: "📊", label: "Performance Insights" },
  { to: "/test", icon: "▷", label: "Take Test" },
  { to: "/practice", icon: "⚡", label: "Adaptive Practice" },
  { to: "/results", icon: "📈", label: "Results" },
  { to: "/jobs", icon: "💼", label: "Job Alerts" },
  { to: "/gk-news", icon: "📰", label: "Current Affairs" },
  { to: "/resources", icon: "🎥", label: "Video Tutorials" },
  { to: "/papers", icon: "📁", label: "Previous Papers" },
  { to: "/cheat-sheets", icon: "📓", label: "Cheat Sheets" },
  { to: "/coding", icon: "💻", label: "Coding Mastery" },
  { to: "/ai-tutor", icon: "✨", label: "AI Tutor" },
];

export default function Layout() {
  const navigate = useNavigate();
  const location = useLocation();
  const name = localStorage.getItem("userName") || "Student";
  const [isOpen, setIsOpen] = useState(false);
  const [notepadOpen, setNotepadOpen] = useState(false);

  // Close sidebar when location changes (on mobile)
  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  function logout() {
    localStorage.clear();
      sessionStorage.clear();
    navigate("/login");
  }

  return (
    <div className="app-shell">
      {/* ── Mobile Header ── */}
      <header className="mobile-header">
        <button className="menu-trigger" onClick={() => setIsOpen(true)}>☰</button>
        <div className="brand" style={{ margin: 0, padding: 0 }}>
          <img src="/logo.png" alt="PrepAct" className="brand-logo-main" />
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button style={{ border: "none", background: "transparent", fontSize: 18 }} onClick={() => setNotepadOpen(true)}>📝</button>
        </div>
      </header>

      {/* ── Sidebar Overlay & Notepad Overlay ── */}
      <div className={`sidebar-overlay ${isOpen || notepadOpen ? "open" : ""}`} onClick={() => { setIsOpen(false); setNotepadOpen(false); }}></div>

      {/* ── Sidebar ── */}
      <aside className={`sidebar ${isOpen ? "open" : ""}`}>
        <div className="brand">
          <img src="/logo.png" alt="PrepAct" className="brand-logo-main" />
        </div>

        <div className="menu-label">Menu</div>

        {NAV.map(n => (
          <NavLink
            key={n.to}
            to={n.to}
            end={n.to === "/"}
            className={({ isActive }) => `nav-item${isActive ? " active" : ""}`}
            onClick={() => setIsOpen(false)}
          >
            <span className="nav-icon">{n.icon}</span>
            {n.label}
          </NavLink>
        ))}

        {/* User + logout at bottom */}
        <div style={{ marginTop: "auto", paddingTop: 16 }}>
          <div style={{ fontSize: 12, color: "var(--text-muted)", padding: "10px 14px" }}>
            👤 {name}
          </div>
          <button
            onClick={logout}
            className="nav-item"
            style={{ width: "100%", border: "none", background: "transparent", textAlign: "left" }}
          >
            <span className="nav-icon">🚪</span>Logout
          </button>
        </div>
      </aside>

      {/* ── Notepad ── */}
      <Notepad isOpen={notepadOpen} onClose={() => setNotepadOpen(false)} />

      {/* ── Floating Action Button for Notes ── */}
      {!notepadOpen && (
        <button className="notes-fab desktop-only" onClick={() => setNotepadOpen(true)} title="Take Notes">
          📝
        </button>
      )}

      {/* ── Main ── */}
      <main className="main-content">
        <div style={{ display: "flex", alignItems: "flex-start" }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <Outlet />
          </div>
          <TopicSidebar />
        </div>
      </main>

      {/* Desktop-only CSS helper for FAB */}
      <style>{`
        @media (max-width: 768px) {
          .notes-fab.desktop-only { display: none; }
        }
      `}</style>
    </div>
  );
}
